import { Button, Col, Row, Skeleton, message } from "antd";
import React, { ReactNode, memo, useEffect, useMemo, useState } from "react";
import { LikeOutlined, LikeFilled } from "@ant-design/icons";
import {
  useEditCommentMutation,
  useGetLikedByUserQuery,
  usePostLikeLoginMutation,
} from "features/comment/service/comment.service";
import { selectToken } from "features/auth/AuthSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setCountLikeReview } from "features/comment/CommentSlice";

type Props = {
  id: number;
  styleWrapper?: React.CSSProperties;
  isLiked: boolean;
  likeCount: number;
  size?: "large" | "middle" | "small";
  type?: "default" | "link" | "text" | "dashed" | "ghost" | "primary";
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
};

const styles = {
  button: {
    fontSize: "12px",
    color: "#898889",
    border: "none",
    boxShadow: "none",
    padding: 0,
    outline: "none",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
    backgroundColor: "white",
  },
  buttonLike: {
    color: "#D72229",
  },
  block: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
  text: {
    fontSize: "12px",
    color: "#898889",
  },
  interactCount: {
    fontSize: "12px",
    color: "#898889",
    marginLeft: "6px",
  },
};

const Reaction = ({
  id,
  isLiked = false,
  styleWrapper,
  likeCount,
  size = "middle",
  type = "default",
}: Props) => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(selectToken);
  const item_id = useAppSelector((state) => state.comment.product_id);
  const item_type = useAppSelector((state) => state.comment.type);

  //

  const [loading, setLoading] = useState<boolean>(false);

  const [messageApi, contextHolder] = message.useMessage();
  //
  const [postLike, postLikeResult] = usePostLikeLoginMutation();
  //

  const [liked, setLiked] = useState<boolean>(false);

  const [count, setCount] = useState(likeCount);
  const {
    data: dataLiked,
    currentData,
    isLoading,
  } = useGetLikedByUserQuery(
    {
      item_id: item_id,
      item_type: item_type,
    },
    { skip: token === null }
  );

  //function
  const handleLike = async (flag: boolean) => {
    if (loading === true) {
      messageApi.open({
        content: "Đừng thao tác nhanh quá nhé !",
        type: "warning",
        duration: 3,
      });
      return;
    }

    setLoading(true);
    if (token) {
      await postLike({ id, like: liked ? -1 : 1 })
        .then((res) => {
          setLiked((prev) => !prev);
          setCount((prev) => {
            if (liked) {
              return prev - 1;
            } else {
              return prev + 1;
            }
          });
        })
        .catch((err) => {
          messageApi.open({
            content: "Có lỗi không thể like !",
            type: "error",
            duration: 3,
          });
        });
      // try {
      //   const res = await postLike({ id, like: liked ? -1 : 1 }).unwrap();
      //   if (res) {
      //     console.log("🚀 ~ file: Reaction.tsx:112 ~ handleLike ~ res:", res);
      //     messageApi.open({
      //       content: !liked
      //         ? "Cảm ơn ban đã để lại 1 like !"
      //         : "Sao lại ko hữu ích cơ chứ !",
      //       type: "success",
      //       duration: 3,
      //     });

      //     // if (liked) {
      //     //   dispatch(setCountLikeReview({ id: id, newCount: likeCount - 1 }));
      //     // } else {
      //     //   dispatch(setCountLikeReview({ id: id, newCount: likeCount + 1 }));
      //     // }
      //     // setLiked((prev) => !prev);
      //   }
      // } catch (error) {
      //   messageApi.open({
      //     content: "Có lỗi không thể like !",
      //     type: "error",
      //     duration: 3,
      //   });
      // }
    } else {
      messageApi.open({
        content: "Bạn cần đăng nhập để thao tác",
        type: "info",
        duration: 3,
      });
    }
    setLoading(false);
  };

  //effect

  useEffect(() => {
    if (dataLiked && dataLiked.length > 0) {
      if (dataLiked.includes(id)) {
        setLiked(true);
      } else {
        setLiked(false);
      }
    }
  }, [isLoading]);

  return (
    <div style={{ ...styleWrapper }}>
      {contextHolder}
      {isLoading ? (
        <Skeleton paragraph={{ rows: 0 }} />
      ) : (
        <Button
          loading={loading}
          disabled={loading}
          style={{ ...styles.block, border: "none", height: 12 }}
          onClick={() => handleLike(!liked)}
        >
          <span style={{ ...styles.button }}>
            {liked ? (
              <LikeFilled style={{ ...styles.buttonLike }} />
            ) : (
              <LikeOutlined />
            )}
            <span style={{ ...styles.text }}>Hữu ích</span>
          </span>
          <span style={{ ...styles.interactCount }}>({count})</span>
        </Button>
      )}
    </div>
  );
};

export default memo(Reaction);
